module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step1_1-e5bd56c3382fb19ba1f57023a3f79989.png";